import React, {useEffect, useMemo, useState} from "react";
import PaginatedFlatTable from "../pagination/PaginatedFlatTable";
import useTranslation from "../../i18n/useTranslation";
import useThemeColors from "../organization/portal/useThemeColors";
import {alphaFromHex} from "../../util/colors";

export default function MarketplaceReportsTable({items = [], title, subtitle, onReview, pageSize = 6}) {
    const {t} = useTranslation();
    const colors = useThemeColors();
    const [page, setPage] = useState(1);
    const pages = Math.max(1, Math.ceil(items.length / pageSize));

    useEffect(() => {
        setPage((currentPage) => Math.min(currentPage, pages));
    }, [pages]);

    const visibleItems = useMemo(() => items.slice((page - 1) * pageSize, page * pageSize), [items, page, pageSize]);

    return <PaginatedFlatTable
        title={title}
        subtitle={subtitle}
        page={page}
        pages={pages}
        items={visibleItems}
        totalCount={items.length}
        onPageChange={setPage}
        headers={[t("marketplaceModerationPage.reportListing", {}, "Listing"), t("marketplaceModerationPage.reportReason", {}, "Reason"), t("marketplaceModerationPage.reportActions", {}, "Actions")]}
        renderRow={(report) => <tr key={report.id}>
            <td style={{color: "#263241", fontWeight: 900}}>{report.listing?.title || t("marketplaceModerationPage.deletedListing")}</td>
            <td><span className="badge badge-light" style={{borderRadius: 999, color: "#667085", fontWeight: 800}}>{report.reason}</span><div className="small text-muted mt-1">{report.details || t("marketplaceModerationPage.noDetails")}</div></td>
            <td className="text-right" style={{whiteSpace: "nowrap"}}>
                <button className="btn btn-sm mr-1" type="button" onClick={() => onReview(report, "dismissed")} style={{borderRadius: 10, padding: "8px 11px", border: `1px solid ${alphaFromHex(colors.primary, .16)}`, background: "#f3f5f7", color: "#4b5563", fontWeight: 800}}><i className="fas fa-times mr-1"/>{t("marketplaceModerationPage.dismiss")}</button>
                <button className="btn btn-sm" type="button" onClick={() => onReview(report, "reviewed")} style={{borderRadius: 10, padding: "8px 11px", border: `1px solid ${alphaFromHex(colors.secondary, .28)}`, background: colors.secondary, color: colors.textOnSecondary, fontWeight: 800}}><i className="fas fa-check mr-1"/>{t("marketplaceModerationPage.markReviewed")}</button>
            </td>
        </tr>}
    />;
}
